export default "__VITE_ASSET__6270a668__"